var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "52.000000pt",
    height: "52.000000pt",
    viewBox: "0 0 52.000000 52.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,52.000000) scale(0.100000,-0.100000)",
    fill: "#009CFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 463 c-64 -169 -81 -225 -76 -239 12 -31 33 4 77 126 29 80 48 120 58 120 32 0 241 -45 241 -51 0 -15 -93 -276 -111 -311 -39 -77 -100 -87 -119 -19 -10 36 -13 39 -117 80 -66 26 -110 38 -116 32 -14 -14 1 -66 26 -89 28 -26 220 -112 250 -112 38 0 85 37 110 87 41 81 131 353 121 363 -7 7 -295 70 -320 70 -1 0 -12 -26 -24 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 391 c0 -15 6 -21 21 -21 14 0 19 5 17 17 -5 26 -38 29 -38 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 378 c-10 -16 21 -35 68 -43 42 -8 68 5 46 22 -12 8 -86 33 -101 33 -3 0 -9 -5 -13 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 306 c0 -15 24 -28 34 -19 13 14 5 33 -14 33 -11 0 -20 -6 -20 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 302 c-16 -15 -1 -32 41 -46 26 -9 53 -16 60 -16 15 0 18 26 3 35 -19 12 -99 33 -104 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 231 c0 -15 6 -21 21 -21 14 0 19 5 17 17 -5 26 -38 29 -38 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 220 c-22 -13 4 -36 56 -50 34 -10 48 -10 57 -1 7 7 7 14 1 20 -18 16 -101 39 -114 31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.84a66eaa21ca378d3d52332a3ae22010.svg";
export { ForwardRef as ReactComponent };